import type { TranslationKey } from '@mwl/core-lib';

export const validationKeys = {
  minSize: ['upload_field.min_size_error', 'Invalid file size'],
  maxSize: ['upload_field.max_size_error', 'Invalid file size'],
  extension: ['upload_field.extension_error', 'Invalid file extension'],
};

export const uploadError: TranslationKey = ['upload_field.uploading_error', 'Error uploading file'];
